import React, { Component } from 'react';
// import products from '../data/products';
import { Panel } from 'react-bootstrap';
//Checkbox
import Checkbox from 'rc-checkbox';
import 'rc-checkbox/assets/index.css';
import { withTranslation } from "react-i18next";

class Products extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            openProduct: true,
            selectedProduct: '',
            selectedProductName: '',
            isCompletedProduct: false,
            zmp: ''
        }
    }

    ///////////SELECTION 
    selectProduct = (event) => {
        let productName = event.currentTarget.id // TODO should be removed, there's no pic here, only display value for the selected line card
        let productZMP = event.currentTarget.getAttribute('value')

        var btns = document.getElementsByClassName("bulpList");

        for (var i = 0; i < btns.length; i++) {
            if(!btns[i].classList.contains("unactive-bulp-list")) {
                btns[i].className += " unactive-bulp-list";
            }
        }

        event.currentTarget.className = "bulpList";
        this.handleProductDetails(productZMP, productName)
    }

    handleProductDetails = (productZMP, productName) => {
        if (typeof productName !== "undefined") {
            this.setState({
                openProduct: true,
                selectedProduct: productZMP,
                selectedProductName: productName,
                zmp: productZMP
            })
            //Passing picture to display
            this.props.completeFormProduct(productName)
        }

        // Passing state are dot finish to allow jumping from dot to dot
        this.props.jumpFour(productZMP)
        this.props.getProductZmp(productZMP)
    }
    ///////////SELECTION END

    componentDidMount() {
        this.setState({
            originalUseCookies: this.props.useCookies
        })

        if (this.props.zmpFromURL) {
            this.handleProductDetails(this.props.zmpFromURL, 'display')
            this.props.resetFromURL()
        }
    }

    renderPillar(title,pillars) {
        if (pillars == null || pillars.length === 0) {
            return ''
        } else
            return (
                <div>
                    <h5><span>{title}</span></h5>
                    <ul>
                        {pillars ? pillars.map((product) =>
                            <li key={product.zmp}><div className="bulpList unactive-bulp-list" id={(product.color != null ? 'display' : 'none')} onClick={this.selectProduct} value={product.zmp} style={{ 'background': product.color }}><span>{product.use_name}</span></div></li>
                        ) : this.props.t("product.loading") }
                    </ul>
                </div>)
    }

    renderPillarExtended(title, subtitle, pillars) {
        if (pillars == null || pillars.length === 0) {
            return ''
        } else
            return (
                <div>
                    <h5>{title}</h5>
                    <h5>{subtitle}</h5>
                    <ul>
                        {pillars ? pillars.map((product, index) =>
                            <li><div className="bulpList unactive-bulp-list" id={(product.color != null ? 'display' : 'none')} onClick={this.selectProduct} key={index} value={product.zmp} style={{ 'background': product.color }}><span style={{ 'font-weight': 'bold' }}>{product.use_name}</span><br /></div></li>
                        ) : this.props.t("product.loading") }
                    </ul>
                </div>)
    }

    isKBASearchAvailable = () => {
        return this.props.getLang() === 'de_de' && this.props.kind && this.props.kind === 1
    }

    render() {
        const { t } = this.props;
        if (!this.props.productsList || this.props.productsList.length === 0) {
            return (<p>{t("product.noData")}</p>)
        }

        // since we're using colors returned from backend to flag pillar we can't display those without it
        let withColor = this.props.productsList.filter(product => product.color != null)
        let pillar1 = withColor.filter(product => product.pillar === '1')
        let pillar2 = withColor.filter(product => product.pillar === '2')
        let pillar3 = withColor.filter(product => product.pillar === '3')
        let pillar4 = withColor.filter(product => product.pillar === '4')
        let pillar5 = withColor.filter(product => product.pillar === '5')

       
        return (
            <div>
                <Panel id="collapsible-panel-example-1" expanded={this.state.openProduct} className="row" onToggle={() => { }}>
                    <Panel.Collapse className="col-xs-12 tech-collapse">
                        <Panel.Body>
                            <div id="bulb-list-container" className="tech-parent">
                                <h4>{t("product.productsTitle")}</h4>
                                <p>{t("product.productsDescription")}</p>
                                <form onSubmit={this.handleSubmit} >
                                    <div className="tech">
                                        {this.renderPillar(t("product.performanceTitle"), pillar1)}
                                        {this.renderPillar(t("product.designTitle"), pillar2)}
                                        {this.renderPillar(t("product.comfortTitle"), pillar3)}
                                        {this.renderPillar(t("product.originalTitle"), pillar4)}
                                        {this.renderPillar(t("product.innovationTitle"), pillar5)}
                                    </div>
                                    {this.props.showCookiesSection || this.props.useCookies ?
                                        <p className="check-cookie">
                                            <label >
                                                <Checkbox onChange={(event) => this.props.toggleCookieUsage()} />
                                                &nbsp; {this.state.originalUseCookies ? t("product.checkboxSelected") : t("product.checkboxNotSelected")}
                                            </label>
                                        </p>
                                        : null}
                                </form>
                            </div>
                        </Panel.Body>
                        {this.props.showCookiesSection && !this.state.originalUseCookies ?
                            //eslint-disable-next-line
                            <p>{t("product.policyIntro")} <a href={this.props && this.props.getLang() === "de_de" ? "https://www.osram.de/cb/services/cookie-policy/index.jsp" : "https://www.osram.com.cn/cb/services/cookie-policy/index.jsp"} target="_blank" className="cookie">{t("product.policyCTA")}</a></p>
                            : null}
                    </Panel.Collapse>
                    {/*Display + or - , toogle openBrand and show minus or plus*/}
                    <div onClick={() => this.setState({ openProduct: !this.state.openProduct }, this.props.selectDotFour)} className={(this.state.openProduct) ? "" : "col-xs-12"}>
                        <div className={(this.state.openProduct) ? "accordion-icon ms-icon_minus" : "accordion-icon ms-icon_plus"}>
                        </div>
                        {/* Display or not when accordion expand or colapse , and on change can open or collapse panel*/}
                        <div className={(this.state.openProduct || !this.state.selectedProductName) ? "none" : "display"} >
                                    <h4>{t("product.compatibleProducts")}</h4>
                            <p>{this.state.selectedProductName} <span className="change" onClick={() => this.setState({ openProduct: !this.state.openProduct })}>{t("product.change")}</span></p>
                        </div>
                    </div>
                </Panel>
            </div>
        )
    }
}

export default withTranslation()(Products);